import { Action, ActionType } from "models/messagemanagement/sendMessages";
import { IResponse } from "models";
import createReducer from "../../createReducer";

export interface SendMessageReducerType {
  loading: boolean;
  error?: string;
  sendMessageResponse?: IResponse;
}

const defaultState: SendMessageReducerType = {
  loading: false,
  error: undefined,
  sendMessageResponse: undefined,
};

export const sendMessageReducer = createReducer<SendMessageReducerType>(
  defaultState,
  {
    [ActionType.SEND_MESSAGE](state: SendMessageReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.SEND_MESSAGE_ERROR](
      state: SendMessageReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.SEND_MESSAGE_SUCCESS](
      state: SendMessageReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        sendMessageResponse: action.payload,
      };
    },

    [ActionType.RESET_SEND_MESSAGE_DATA](state: SendMessageReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        sendMessageResponse: [],
      };
    },
  }
);
